import React, { useState } from 'react';
import { Mail } from 'lucide-react';

const NewsletterCTA: React.FC = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');

    try {
      const res = await fetch('/.netlify/functions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setStatus('success');
        setMessage('You\'re in. Welcome to UTXOMacro.');
        setEmail('');
      } else {
        throw new Error('Subscribe failed');
      }
    } catch {
      // Graceful fallback for GitHub Pages / non-Netlify environments
      setStatus('error');
      setMessage('Newsletter subscription temporarily unavailable. Follow us on X @UTXOMacro for updates.');
    }
  };

  return (
    <section
      className="relative py-20 overflow-hidden"
      style={{
        background: '#0D0D0D',
      }}
    >
      {/* Radial orange glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 60% 40% at 50% 50%, rgba(247,147,26,0.07) 0%, transparent 70%)',
        }}
      />

      <div className="relative z-10 max-w-2xl mx-auto px-4 sm:px-6 text-center">
        <div className="flex justify-center mb-4">
          <div className="p-3 rounded-full bg-[#F7931A]/10 border border-[#F7931A]/20">
            <Mail size={22} className="text-[#F7931A]" />
          </div>
        </div>

        <h2 className="text-3xl sm:text-4xl font-bold mb-3 text-gradient">
          Stay Ahead of the Market
        </h2>
        <p className="text-gray-400 text-base mb-8">
          Bitcoin, Macro, and AI intelligence in your inbox. No spam.
        </p>

        {status === 'success' ? (
          <div className="bg-[#00C896]/10 border border-[#00C896]/30 rounded-xl px-6 py-4 text-[#00C896] font-medium">
            {message}
          </div>
        ) : (
          <>
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                required
                className="flex-1 bg-[#111] border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 text-sm focus:outline-none focus:border-[#F7931A]/50 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="bg-[#F7931A] text-black font-semibold text-sm px-6 py-3 rounded-lg hover:bg-[#e8871a] transition-colors disabled:opacity-60 whitespace-nowrap"
              >
                {status === 'loading' ? 'Subscribing...' : 'Subscribe Free'}
              </button>
            </form>
            {status === 'error' && (
              <p className="text-gray-500 text-xs mt-4">{message}</p>
            )}
          </>
        )}

        <p className="text-gray-700 text-xs mt-5">
          Join thousands of investors tracking Bitcoin, macro trends, and AI. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
};

export default NewsletterCTA;
